var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "about",
            "title": "기업소개",
            "src": "/images/sub/subvisual-about.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first grey darken-4 white--text",
    attrs: {
      "id": "about-vision"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('span', {
          staticClass: "font-secondary"
        }, [_vm._v("Farming Tomorrow")])];
      },
      proxy: true
    }, {
      key: "text",
      fn: function fn() {
        return [_c('span', {
          staticClass: "white--text"
        }, [_c('b', {
          staticClass: "primary--text"
        }, [_vm._v("농업의 미래를 함께합니다.")]), _vm._v(" 농업의 미래로 함께 갑니다.")])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "mb-60px mb-md-80px mb-lg-100px",
    attrs: {
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  }, [_c('v-img', {
    staticClass: "d-md-none mx-auto",
    attrs: {
      "max-width": "300",
      "aspect-ratio": 700 / 2020,
      "src": "/images/sub/about/about-img-mo.png"
    }
  }), _c('v-img', {
    staticClass: "d-none d-md-block",
    attrs: {
      "aspect-ratio": 1200 / 426,
      "src": "/images/sub/about/about-img.png"
    }
  })], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-divider', {
    staticStyle: {
      "border-color": "rgba(255,255,255,0.2)"
    }
  }), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-40px py-md-36px px-lg-80px"
  }, [_c('div', {
    staticClass: "tit tit--xl font-secondary"
  }, [_vm._v("Vision")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-36px px-lg-80px"
  }, [_c('p', {
    staticClass: "txt txt--xl white--text"
  }, [_vm._v("스마트팜 솔루션을 제공함으로써 농민상생과 지속 가능한 미래농업의 생태계를 구축합니다.")])])])], 1)], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('v-divider', {
    staticStyle: {
      "border-color": "rgba(255,255,255,0.2)"
    }
  }), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-40px py-md-36px px-lg-80px"
  }, [_c('div', {
    staticClass: "tit tit--xl font-secondary"
  }, [_vm._v("Mission")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-36px px-lg-80px"
  }, [_c('p', {
    staticClass: "txt txt--xl white--text"
  }, [_vm._v("미래의 식량문제를 해결하고 최신 기술과 혁신적인 아이디어를 활용하여 농업의 생산성을 높이고 환경오염을 최소화하는 스마트팜 솔루션을 개발합니다.")])])])], 1), _c('v-divider', {
    staticStyle: {
      "border-color": "rgba(255,255,255,0.2)"
    }
  })], 1)]), _c('page-section', {
    staticClass: "pb-0",
    attrs: {
      "id": "about-greeting"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v("대표 인사말")];
      },
      proxy: true
    }])
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5",
      "data-aos": "fade-left",
      "data-aos-delay": "100"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": _vm.$vuetify.breakpoint.mdAndUp ? 486 : 370,
      "aspect-ratio": 486 / 534,
      "src": "/images/sub/about/greeting-img.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7",
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "pt-10px pt-md-0 pl-md-24px"
  }, [_c('div', {
    staticClass: "txt txt--xl txt--dark"
  }, [_c('p', [_vm._v("이레아이에스는 IT 컨버전스 시대에 부응하는 IT소프트웨어 솔루션을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("개발 제조, 공급하는 전문회사로 2010년 9월 법인을 설립한 이래 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("다양하고 폭 넓은 경험을 바탕으로 친환경 농업과 고효율 에너지 솔루션 개발에 혼신의 힘을 다하고 있습니다.")]), _c('p', [_vm._v("국내외 급변하는 IT 컨버전스 시장에 능동적으로 대처하는 농업분야의 DX(디지털전환) 전문기업으로서 끊임없는 변화와 창의적 발상을 통한 고객 감동의 가치 창조를 제고하고 산업을 선도하는 글로벌 기업이 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("되기 위하여 매진하고 있으며, 감사, 겸손, 담대한 마음을 바탕으로 건전한 기업 윤리 경영 준수를 통해 투명하고 깨끗한 기업 문화확립을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("위해 최선을 다 하고 있습니다.")]), _c('div', {
    staticClass: "mt-6px"
  }, [_c('v-row', {
    staticClass: "row--xs",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "txt--lg"
  }, [_vm._v("(주)이레아이에스 대표이사")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b', [_vm._v("장석환")])])], 1)], 1)])])])], 1)], 1), _c('page-section', {
    staticClass: "pb-0",
    attrs: {
      "id": "about-history"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v("연혁")];
      },
      proxy: true
    }])
  }, [_c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px"
  }, [_c('div', {
    staticClass: "w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2"
  }, [_vm._v("2023")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-24px px-lg-60px"
  }, [_c('div', [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("춘천하나로마트 식물공장 입점")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("표준 생장 환경 기준용 유사 기후대 농장 분류 인공지능 솔루션 개발")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("전문건설업 등록")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("두바이 MLED사 배지함수율 측정장치(알엠팜) 100대 수출계약")])], 1)], 1)])])], 1), _c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px"
  }, [_c('div', {
    staticClass: "w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2"
  }, [_vm._v("2022")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-24px px-lg-60px"
  }, [_c('div', [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("배지함수율 측정장치(알엠팜) 혁신제품 지정인증(농림축산식품부)")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("한국식자재유통협회와 저탄소 상품 확대 추진을 위한 업무협약 체결")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("디지털 혁신 우수사례 기업선정")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("데이터 기반 스마트농업 확산 지원 사업 최우수 사례 선정")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("농업회사법인 팜이레 설립")])], 1)], 1)])])], 1), _c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px"
  }, [_c('div', {
    staticClass: "w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2"
  }, [_vm._v("2021")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-24px px-lg-60px"
  }, [_c('div', [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("소재·부품·장비 전문기업 획득")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("신성장동력 기술사업화 지원사업 우수사례 선정 표창")])], 1)], 1)])])], 1), _c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px"
  }, [_c('div', {
    staticClass: "w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2"
  }, [_vm._v("2020")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-24px px-lg-60px"
  }, [_c('div', [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("대표이사 과기정통부 장관상 수상(인공지능 빅데이터 장비 과학기술 부문)")])], 1)], 1)])])], 1), _c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px"
  }, [_c('div', {
    staticClass: "w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2"
  }, [_vm._v("2019")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-24px px-lg-60px"
  }, [_c('div', [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("토경 재배작물의 데이터 센싱 통한 All-in-One복합환경 제어 시스템 개발")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("농림축산식품부 장관상 수상(과학기술 및 보급 부문)")])], 1)], 1)])])], 1), _c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px"
  }, [_c('div', {
    staticClass: "w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2"
  }, [_vm._v("2018")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-24px px-lg-60px"
  }, [_c('div', [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("작물 근권 환경 데이터의 기계학습을 통한 All-in-One관수제어 시스템 개발")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("양액 재배 딸기의 근권 관리를 위한 스마트 재배환경 관리시스템 개발")])], 1)], 1)])])], 1), _c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px"
  }, [_c('div', {
    staticClass: "w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2"
  }, [_vm._v("2017")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-24px px-lg-60px"
  }, [_c('div', [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("시설재배 단동 하우스의 외기 및 토양환경 측정 시스템 개발")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("덴마크SENMATIC사와 관수시스템 기술교류")])], 1)], 1)])])], 1), _c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px"
  }, [_c('div', {
    staticClass: "w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2"
  }, [_vm._v("2014")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-24px px-lg-60px"
  }, [_c('div', [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("핀란드 VTT 연구소와 MOU체결")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("ICBM기반 에너지 단위기술 조합통한 시설재배 에너지 컨설팅 플랫폼 개발")])], 1)], 1)])])], 1), _c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px"
  }, [_c('div', {
    staticClass: "w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2"
  }, [_vm._v("2013")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-24px px-lg-60px"
  }, [_c('div', [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("양액 재배시설 근권부 함수율 측정 통한 재배 환경 개선 시스템")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("강릉 원예 수출 영농조합과 파프리카 농장 운영")])], 1)], 1)])])], 1), _c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px"
  }, [_c('div', {
    staticClass: "w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2"
  }, [_vm._v("2012")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-24px px-lg-60px"
  }, [_c('div', [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("독일 FTK사와 스마트팜 분야 EU RnD, FP7 사업 진행")])], 1)], 1)])])], 1), _c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px"
  }, [_c('div', {
    staticClass: "w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2"
  }, [_vm._v("2011")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-24px px-lg-60px"
  }, [_c('div', [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("스마트 통합 건물 에너지 모니터링 시스템")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("고부가가치 지역특산 성장환경 모니터링 시스템")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("독일 FTK사와 농업 IT분야 기술 개발 사업협의")])], 1)], 1)])])], 1), _c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px"
  }, [_c('div', {
    staticClass: "w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2"
  }, [_vm._v("2010")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "px-12px pb-12px px-md-40px py-md-24px px-lg-60px"
  }, [_c('div', [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("독일 Fraunhofer IFF와 작물 영상 분석 기술협의")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("USN 기반 농작물 생장환경 관리 시스템")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("식물 생장용 컨테이너 시스템")])], 1)], 1), _c('div', {
    staticClass: "pt-4px pt-md-8px"
  }, [_c('v-row', {
    staticClass: "row--xxs txt txt--xxl txt--dark line-height-15"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("주식회사 이레아이에스 설립")])], 1)], 1)])])], 1), _c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1)]), _c('page-section', {
    attrs: {
      "id": "about-cibi"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v("CI/BI")];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mb-20px mb-md-24px"
        }, [_c('h4', {
          staticClass: "tit tit--lg",
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "100"
          }
        }, [_vm._v("CI")])]), _c('v-card', {
          staticClass: "grey lighten-2",
          attrs: {
            "outlined": "",
            "data-aos": "fade",
            "data-aos-delay": "200"
          }
        }, [_c('v-img', {
          staticClass: "d-md-none",
          attrs: {
            "aspect-ratio": 726 / 392,
            "src": "/images/sub/about/cibi-img-mo.jpg"
          }
        }), _c('v-img', {
          staticClass: "d-none d-md-block",
          attrs: {
            "aspect-ratio": 1198 / 330,
            "src": "/images/sub/about/cibi-img.jpg"
          }
        })], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mb-20px mb-md-24px"
        }, [_c('h4', {
          staticClass: "tit tit--lg",
          attrs: {
            "data-aos": "fade-up",
            "data-aos-delay": "100"
          }
        }, [_vm._v("BI")])]), _c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "3",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-card', {
          staticClass: "grey lighten-2",
          attrs: {
            "outlined": ""
          }
        }, [_c('v-img', {
          attrs: {
            "aspect-ratio": 282 / 206,
            "src": "/images/sub/about/cibi-img2.jpg"
          }
        })], 1), _c('div', {
          staticClass: "text-center mt-6px mt-md-16px"
        }, [_c('div', {
          staticClass: "txt txt--xl txt--dark"
        }, [_vm._v("알엠팜")])])], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "3",
            "data-aos": "fade",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          staticClass: "grey lighten-2",
          attrs: {
            "outlined": ""
          }
        }, [_c('v-img', {
          attrs: {
            "aspect-ratio": 282 / 206,
            "src": "/images/sub/about/cibi-img3.jpg"
          }
        })], 1), _c('div', {
          staticClass: "text-center mt-6px mt-md-16px"
        }, [_c('div', {
          staticClass: "txt txt--xl txt--dark"
        }, [_vm._v("파밍온")])])], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "3",
            "data-aos": "fade",
            "data-aos-delay": "300"
          }
        }, [_c('v-card', {
          staticClass: "grey lighten-2",
          attrs: {
            "outlined": ""
          }
        }, [_c('v-img', {
          attrs: {
            "aspect-ratio": 282 / 206,
            "src": "/images/sub/about/cibi-img4.jpg"
          }
        })], 1), _c('div', {
          staticClass: "text-center mt-6px mt-md-16px"
        }, [_c('div', {
          staticClass: "txt txt--xl txt--dark"
        }, [_vm._v("파밍온2")])])], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "3",
            "data-aos": "fade",
            "data-aos-delay": "400"
          }
        }, [_c('v-card', {
          staticClass: "grey lighten-2",
          attrs: {
            "outlined": ""
          }
        }, [_c('v-img', {
          attrs: {
            "aspect-ratio": 282 / 206,
            "src": "/images/sub/about/cibi-img5.jpg"
          }
        })], 1), _c('div', {
          staticClass: "text-center mt-6px mt-md-16px"
        }, [_c('div', {
          staticClass: "txt txt--xl txt--dark"
        }, [_vm._v("팜이레")])])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('page-section', {
    staticClass: "page-section--last grey darken-4 white--text",
    attrs: {
      "id": "about-technology"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v("기술인증 현황")];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "tabs-wrap"
  }, [_c('v-tabs', {
    staticClass: "v-tabs--btn v-tabs--dark",
    attrs: {
      "hide-slider": "",
      "show-arrows": "",
      "centered": "",
      "center-active": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('u-tab', {
    attrs: {
      "to": "#about-patent",
      "id": "about-patent"
    }
  }, [_vm._v("특허")]), _c('u-tab', {
    attrs: {
      "to": "#about-certification",
      "id": "about-certification"
    }
  }, [_vm._v("인증")]), _c('u-tab', {
    attrs: {
      "to": "#about-trademark",
      "id": "about-trademark"
    }
  }, [_vm._v("상표 등록증")]), _c('u-tab', {
    attrs: {
      "to": "#about-design",
      "id": "about-design"
    }
  }, [_vm._v("디자인 등록증")]), _c('u-tab', {
    attrs: {
      "to": "#about-award",
      "id": "about-award"
    }
  }, [_vm._v("수상 / 위촉장")])], 1)], 1), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    attrs: {
      "value": "about-patent",
      "transition": "fade-transition",
      "reverse-transition": "fade-transition"
    }
  }, [_c('v-row', {
    staticClass: "row-cols-lg-5"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/patent-img.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/patent-img2.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/patent-img3.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/patent-img4.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/patent-img5.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/patent-img6.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/patent-img7.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/patent-img8.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/patent-img9.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/patent-img10.jpg"
    }
  })], 1)], 1)], 1)], 1), _c('v-tab-item', {
    attrs: {
      "value": "about-certification",
      "transition": "fade-transition",
      "reverse-transition": "fade-transition"
    }
  }, [_c('v-row', {
    staticClass: "row-cols-lg-5"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/certification-img.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/certification-img2.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/certification-img3.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/certification-img4.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/certification-img5.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/certification-img6.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/certification-img7.jpg"
    }
  })], 1)], 1)], 1)], 1), _c('v-tab-item', {
    attrs: {
      "value": "about-trademark",
      "transition": "fade-transition",
      "reverse-transition": "fade-transition"
    }
  }, [_c('v-row', {
    staticClass: "row-cols-lg-5"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/trademark-img.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/trademark-img2.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/trademark-img3.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/trademark-img4.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/trademark-img5.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/trademark-img6.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/trademark-img7.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/trademark-img8.jpg"
    }
  })], 1)], 1)], 1)], 1), _c('v-tab-item', {
    attrs: {
      "value": "about-design",
      "transition": "fade-transition",
      "reverse-transition": "fade-transition"
    }
  }, [_c('v-row', {
    staticClass: "row-cols-lg-5"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/design-img.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/design-img2.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/design-img3.jpg"
    }
  })], 1)], 1)], 1)], 1), _c('v-tab-item', {
    attrs: {
      "value": "about-award",
      "transition": "fade-transition",
      "reverse-transition": "fade-transition"
    }
  }, [_c('v-row', {
    staticClass: "row-cols-lg-5"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/award-img.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/award-img2.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/award-img3.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/award-img4.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/award-img5.jpg"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "220",
      "aspect-ratio": 220 / 310,
      "src": "/images/sub/about/award-img6.jpg"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }